// A Circle's discussion topics are content-domain topics; the server enforces
// it where a Circle's topics are written. Every Circle surface that lists or
// names them reads this one domain filter.
export const DISCUSSION_TOPIC_DOMAINS = ['content'] as const;
